import DashboardLayout from "../dashboard/layout/DashboardLayout";
import PromptEngineContent from "../prompt-engine/PromptEngineContent";
import { Plus, Sparkles } from "lucide-react";
import { useState, useEffect } from "react";

export default function PromptEnginePage() {
  const [activeTab, setActiveTab] = useState("prompts");
  const [actionButtons, setActionButtons] = useState([]);
  
  // Define action buttons based on active tab
  const getActionButtons = () => {
    // Base buttons that appear on all tabs
    const baseButtons = [];
    
    if (activeTab === "prompts") {
      // Buttons for prompts tab
      return [
        {
          label: "Create Prompt",
          onClick: () => console.log("Create Prompt clicked"),
          icon: <Plus size={16} />,
          variant: "default" as const,
          className: "bg-primary hover:bg-primary/80 text-primary-foreground"
        }
      ];
    } else if (activeTab === "transcripts") {
      // Buttons for transcripts tab
      return [
        {
          label: "Upload Transcript",
          onClick: () => console.log("Upload Transcript clicked"),
          icon: <Plus size={16} />,
          variant: "default" as const,
          className: "bg-primary hover:bg-primary/80 text-primary-foreground"
        }
      ];
    } else if (activeTab === "direct") {
      // Buttons for direct generation tab
      return [
        {
          label: "AI Generate",
          onClick: () => console.log("AI Generate clicked"),
          icon: <Sparkles size={16} />,
          variant: "default" as const,
          className: "bg-primary hover:bg-primary/80 text-primary-foreground"
        }
      ];
    }
    
    // Default empty array if no tab matches
    return [];
  };
  
  // Update action buttons when tab changes
  const handleTabChange = (tab: string) => {
    setActiveTab(tab);
    setActionButtons(getActionButtons());
  };

  // Set initial action buttons on component mount
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    setActionButtons(getActionButtons());
  }, []);
  
  return (
    <DashboardLayout
      activeItem="Prompt Engine"
      title="Prompt Generation Engine"
      description="Create and refine AI prompts based on conversation transcripts"
      actionButtons={actionButtons}
    >
      <PromptEngineContent onTabChange={handleTabChange} hideButtons={true} />
    </DashboardLayout>
  );
}
